import { useEffect, useState } from "react";

import { getDeceased } from "@api/deceased";

export const useDeceased = (
  id: string | number | null,
  isCreatePage: boolean,
) => {
  const [data, setData] = useState<any>({});

  useEffect(() => {
    if (!isCreatePage) {
      getDeceased(id as number)
        .then((data) => setData(data as any))
        .catch((err) => console.log(err));
    }

    return setData({});
  }, [id]);

  return data;
};
